import messages from "@intlify/unplugin-vue-i18n/messages"
import { createI18n } from "vue-i18n"

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: "en",
  fallbackLocale: "en",
  availableLocales: ["en", "de", "it", "fr"],
  messages,
})

// @ts-ignore
export const translate: (key: string) => string = i18n.global.t
